export const DROPDOWN = "WITHDRAWAL_DROPDOWN";
export const STORE = "WITHDRAWAL_STORE";
export const STORE_WITHDRAWAL_CRYPTO_ADDRESS = "STORE_WITHDRAWAL_CRYPTO_ADDRESS";
export const GET_WITHDRAWAL_CRYPTO_ADDRESS = "GET_WITHDRAWAL_CRYPTO_ADDRESS";
export const CRYPTO_WITHDRAWAL_STORE = "CRYPTO_WITHDRAWAL_STORE";
export const WITHDRAWAL_DETAILS = "WITHDRAWAL_DETAILS";
export const GET_CRYPTO_EXCHANGE_RATES = "GET_CRYPTO_EXCHANGE_RATES";